import type { HTMLAttributes } from "react";
import { cn } from "../../../utils/cn";

export interface PageLayoutProps extends HTMLAttributes<HTMLDivElement> {
  maxWidth?: "full" | "lg" | "xl" | "2xl" | "3xl" | "4xl" | "5xl" | "6xl" | "7xl";
  padded?: boolean;
}

const widthMap = {
  full: "max-w-none w-full",
  lg: "max-w-lg",
  xl: "max-w-xl",
  "2xl": "max-w-2xl",
  "3xl": "max-w-3xl",
  "4xl": "max-w-4xl",
  "5xl": "max-w-5xl",
  "6xl": "max-w-6xl",
  "7xl": "max-w-7xl",
} as const;

export function PageLayout({
  maxWidth = "7xl",
  padded = true,
  className,
  ...props
}: PageLayoutProps) {
  return (
    <div className={cn("mx-auto", widthMap[maxWidth], padded && "p-6", className)} {...props} />
  );
}

export default PageLayout;
